import { INVOICE_NO_MAX_LENGTH, VALIDATION_FIELDS } from '../constants/returnRequestConstants';

/**
 * İade talebi form validasyonu
 * @param {Object} formData - Form verileri
 * @param {Function} th - Translation fonksiyonu
 * @param {Object} options - { requireInvoiceNo: yurt dışı bayide Fatura No zorunlu }
 * @returns {Object} - Hata objesi
 */
export const validateReturnRequestForm = (formData, th, { requireInvoiceNo = false } = {}) => {
    const errors = {};

    // Parça seçimi kontrolü
    if (!formData.partCode) {
        errors[VALIDATION_FIELDS.PART] = th('dealerPartsReturnProcess.returnRequest.validation.partRequired') || 'Parça seçimi zorunludur';
    }

    // İade nedeni kontrolü
    if (!formData.selectedReasonType) {
        errors[VALIDATION_FIELDS.SELECTED_REASON_TYPE] = th('dealerPartsReturnProcess.returnRequest.validation.returnReasonTypeRequired');
    }

    // Miktar kontrolü
    if (!formData.quantity || formData.quantity <= 0) {
        errors[VALIDATION_FIELDS.QUANTITY] = th('dealerPartsReturnProcess.returnRequest.validation.returnQuantityRequired');
    }

    if (requireInvoiceNo) {
        const invoiceNo = formData.invoiceNo?.trim() || '';
        if (!invoiceNo) {
            errors[VALIDATION_FIELDS.INVOICE_NO] = th('dealerPartsReturnProcess.returnRequest.validation.invoiceNoRequired');
        } else if (invoiceNo.length > INVOICE_NO_MAX_LENGTH) {
            errors[VALIDATION_FIELDS.INVOICE_NO] = th('dealerPartsReturnProcess.returnRequest.validation.invoiceNoMaxLength');
        }
    }

    // Arızalı parça için ek kontroller
    if (formData.isFaultyPart) {
        if (!formData.chassisNo) {
            errors[VALIDATION_FIELDS.CHASSIS_NO] =
             th('dealerPartsReturnProcess.returnRequest.validation.chassisNoRequired');
        }
        if (!formData.assemblyKm) {
            errors[VALIDATION_FIELDS.ASSEMBLY_KM] =
             th('dealerPartsReturnProcess.returnRequest.validation.assemblyKmRequired');
        }
        if (!formData.faultKm) {
            errors[VALIDATION_FIELDS.FAULT_KM] =
             th('dealerPartsReturnProcess.returnRequest.validation.faultKmRequired');
        }
        if (!formData.assemblyDate) {
            errors[VALIDATION_FIELDS.ASSEMBLY_DATE] =
             th('dealerPartsReturnProcess.returnRequest.validation.assemblyDateRequired');
        }
        if (!formData.faultDate) {
            errors[VALIDATION_FIELDS.FAULT_DATE] =
             th('dealerPartsReturnProcess.returnRequest.validation.faultDateRequired');
        }
    }

    return errors;
};

/**
 * Form validasyonunun başarılı olup olmadığını kontrol eder
 * @param {Object} errors - Hata objesi
 * @returns {boolean}
 */
export const isFormValid = (errors) => {
    return Object.keys(errors).length === 0;
};
